export var InputType;
(function (InputType) {
    InputType["TEXT"] = "Text";
    InputType["TEXTAREA"] = "TextArea";
    InputType["NUMBER"] = "Number";
    InputType["CHECKBOX"] = "CheckBox";
    InputType["RADIO"] = "Radio";
    InputType["SELECT"] = "Select";
    InputType["DATE"] = "Date";
    InputType["DATETIME"] = "DateTime";
    InputType["PHOTO"] = "Photo";
    InputType["TIME"] = "Time";
    InputType["FILE"] = "File";
    InputType["IMAGE"] = "Image";
    InputType["EMAIL"] = "Email";
    InputType["PHONE"] = "Phone";
    InputType["COLOR"] = "Color";
    InputType["RANGE"] = "Range";
    InputType["HIDDEN"] = "Hidden";
    InputType["PASSWORD"] = "Password";
    InputType["AUTO_COMPLETE"] = "AutoComplete";
    InputType["LIST_SEARCH"] = "ListSearch";
    InputType["MULTI_SELECT"] = "MultiSelect";
    InputType["MULTI_CHECKBOX"] = "MultiCheckbox";
    InputType["DOUBLE"] = "Double";
    InputType["SWITCH"] = "Switch";
})(InputType || (InputType = {}));
export var DataType;
(function (DataType) {
    DataType["UUID"] = "Uuid";
    DataType["INT"] = "Int";
    DataType["FLOAT"] = "Float";
    DataType["NUMERIC"] = "Numeric";
    DataType["DOUBLE"] = "Double";
    DataType["BOOL"] = "Bool";
    DataType["TIMESTAMP"] = "Timestamp";
    DataType["DATE"] = "Date";
    DataType["TIME"] = "Time";
    DataType["TEXT"] = "Text";
    DataType["VARCHAR"] = "Varchar";
    DataType["JSON"] = "Json";
    DataType["GEOM_POINT"] = "GeomPoint";
    DataType["GEOM_LINE"] = "GeomLine";
    DataType["GEOM_POLYGON"] = "GeomPolygon";
})(DataType || (DataType = {}));
export var FieldTag;
(function (FieldTag) {
    FieldTag["CONDITION"] = "Condition";
    FieldTag["DBH"] = "DBH";
    FieldTag["GEOMETRY"] = "Geometry";
    FieldTag["LATITUDE"] = "Latitude";
    FieldTag["LONGITUDE"] = "Longitude";
    FieldTag["ARCHIVED"] = "Archived";
    FieldTag["ADDRESS"] = "Address";
    FieldTag["SPECIES_CODE"] = "SpeciesCode";
    FieldTag["SPECIES_COMMON"] = "SpeciesCommon";
    FieldTag["SPECIES_LATIN"] = "SpeciesLatin";
    FieldTag["STATUS"] = "Status";
    FieldTag["PHOTOS"] = "Photos";
    FieldTag["LAST_MODIFIED"] = "LastModified";
    FieldTag["LAST_MODIFIED_USER"] = "LastModifiedUser";
    FieldTag["CREATED_BY"] = "CreatedBy";
    FieldTag["ASSET_CLASS_PRIMARY_IDENTIFIER"] = "AssetClassPrimaryIdentifier";
    FieldTag["NOTES"] = "Notes";
    FieldTag["TREE_HEIGHT"] = "TreeHeight";
    FieldTag["OBSERVATIONS"] = "Observations";
    FieldTag["OBSERVATIONS_ABIOTIC"] = "ObservationsAbiotic";
    FieldTag["OBSERVATIONS_BIOTIC"] = "ObservationsBiotic";
    FieldTag["OBSERVATIONS_CHARACTERISTICS"] = "ObservationsCharacteristics";
    FieldTag["OBSERVATION_COMMENTS"] = "ObservationComments";
    FieldTag["DATE_CREATED"] = "DateCreated";
    FieldTag["ORGANIZATION"] = "Organization";
    FieldTag["CROWN_PERCENT_DIEBACK"] = "CrownPercentDieback";
    FieldTag["CROWN_CONDITION"] = "CrownCondition";
    FieldTag["LAND_USE"] = "LandUse";
    FieldTag["CLEARANCE_PRUNE_NEEDED"] = "ClearancePruneNeeded";
    FieldTag["GROWING_SPACE"] = "GrowingSpace";
    FieldTag["LOWEST_BRANCH_HEIGHT"] = "LowestBranchHeight";
    FieldTag["REMOTE_ASSESSED_CLEARANCE_ISSUES"] = "RemoteAssessedClearanceIssues";
    FieldTag["CROWN_DIEBACK_RANGE"] = "CrownDiebackRange";
    FieldTag["RISK_ASSESSED_TREE_PART"] = "RiskAssessedTreePart";
    FieldTag["RISK_LIKELIHOOD_OF_FAILURE"] = "RiskLikelihoodOfFailure";
    FieldTag["RISK_LIKELIHOOD_OF_IMPACTING_TARGET"] = "RiskLikelihoodOfImpactingTarget";
    FieldTag["RISK_LIKELIHOOD"] = "RiskLikelihood";
    FieldTag["RISK_CONSEQUENCE_OF_FAILURE"] = "RiskConsequenceOfFailure";
    FieldTag["RISK_RATING"] = "RiskRating";
    FieldTag["RISK_TARGET"] = "RiskTarget";
    FieldTag["MULTI_STEM_DBH"] = "MultiStemDbh";
    FieldTag["MULTI_STEM_TRIGGER"] = "MultiStemTrigger";
})(FieldTag || (FieldTag = {}));
export var FieldReferenceType;
(function (FieldReferenceType) {
    FieldReferenceType["ASSET_CLASS"] = "AssetClass";
    FieldReferenceType["REFERENCE_TABLE"] = "ReferenceTable";
    FieldReferenceType["FORM"] = "Form";
})(FieldReferenceType || (FieldReferenceType = {}));
export var FieldLifeCycleStatus;
(function (FieldLifeCycleStatus) {
    FieldLifeCycleStatus["ACTIVE"] = "Active";
    FieldLifeCycleStatus["DEPRECATED"] = "Deprecated";
})(FieldLifeCycleStatus || (FieldLifeCycleStatus = {}));
export var FieldLengthMeasurementUnit;
(function (FieldLengthMeasurementUnit) {
    FieldLengthMeasurementUnit["INCH"] = "in";
    FieldLengthMeasurementUnit["FEET"] = "ft";
    FieldLengthMeasurementUnit["YARD"] = "yd";
    FieldLengthMeasurementUnit["MILE"] = "mi";
    FieldLengthMeasurementUnit["MILLIMETER"] = "mm";
    FieldLengthMeasurementUnit["CENTIMETER"] = "cm";
    FieldLengthMeasurementUnit["METER"] = "m";
    FieldLengthMeasurementUnit["KILOMETER"] = "km";
})(FieldLengthMeasurementUnit || (FieldLengthMeasurementUnit = {}));
//# sourceMappingURL=field.interface.js.map